export const getParam = (searchParams: URLSearchParams, param: string): string | undefined => {
    return searchParams.get(param) || undefined;
};
